export default __webpack_public_path__ + "static/media/Arch_AWS-Config_64.5de1711a.svg";